/** Perfis de painel listados em Usuários (mesma allowlist de `PANEL_ROLES` no legado). */
export const PANEL_ROLE_LABELS: Record<string, string> = {
  Admin: 'Admin',
  Client: 'Cliente',
  Owner: 'Dono de rede',
  Manager: 'Gerente',
  Operator: 'Operador',
  Integration: 'Integração',
  Campaign: 'Campanhas',
  Validator: 'Validador',
  Base: 'Base',
};

export function panelRoleLabel(role: string): string {
  return PANEL_ROLE_LABELS[role] ?? role;
}

/** Perfis que o cadastro pode gravar. `Campaign` existe em usuários antigos, mas o schema não aceita na criação. */
export const CREATABLE_PANEL_ROLES = ['Admin', 'Client', 'Owner', 'Manager', 'Operator', 'Integration', 'Validator', 'Base'] as const;
